import { Box, Container, Stack, Typography } from '@mui/material';

import CircleCheck from '../../assets/svg/CircleCheck';
import useSetBannerType from '../../hooks/useSetBannerType';
import useTranslation from '../../hooks/useTranslation';
import { StatusPageStyles } from '../StatusPage/StatusPage.styles';

const DraftCompletePage = () => {
    const translate = useTranslation();
    useSetBannerType('none');
    return (
        <Container sx={StatusPageStyles}>
            <Box justifyContent="center" marginBottom={2} marginTop={2}>
                <Stack justifyContent={'flex-end'} alignItems={'center'} spacing={2}>
                    <CircleCheck />
                    <Typography variant={'h6'} noWrap height={48}>
                        {translate('page.draft-complete.title')}
                    </Typography>
                </Stack>
                <Stack justifyContent={'flex-end'} alignItems={'center'} spacing={2}>
                    <Typography variant={'body1'}>{translate('page.draft-complete.description')}</Typography>
                </Stack>
            </Box>
        </Container>
    );
};

export default DraftCompletePage;
